module.exports = __webpack_public_path__ + "static/media/create_labels_create_edit_delete.1dc2964a.mov";